(function () {
  "use strict";

// [module] src/runtime/modules/theme/init-modules.mjs
function bootstrapThemeModules() {
  window.theme = window.theme || {};
  var theme = window.theme;

  theme.modules = theme.modules || {};

  theme.register = theme.register || function (name, factory) {
    if (!name || typeof factory !== 'function') return;
    theme.modules[name] = factory;
  };

  theme.initModules = theme.initModules || function (root) {
    root = root || document;
    var nodes = [];
    if (root.matches && root.matches('[data-module]')) {
      nodes.push(root);
    }
    Array.prototype.push.apply(nodes, root.querySelectorAll('[data-module]'));
    Array.prototype.forEach.call(nodes, function (node) {
      var name = node.getAttribute('data-module');
      var factory = theme.modules[name];
      if (typeof factory !== 'function') return;
      if (node.__themeModuleInitialized) return;
      node.__themeModuleInitialized = true;
      try {
        factory(node);
      } catch (error) {
        console.error('Theme module init failed:', name, error);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    theme.initModules(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event && event.target ? event.target : document;
    theme.initModules(sectionRoot);
  });
}

// [module] src/runtime/entries/theme-init.mjs

(function () {
  bootstrapThemeModules();
})();

})();
